"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = require("./request");
var activityLog = require("./activity-log/activity-log");
var activityLogSleep = require("./activity-log/activity-log-sleep");
var activityLogTypes = require("./activity-log/activity-log-types");
var calorieTargets = require("./calorie-targets/calorie-targets");
var console = require("./console/console");
var dailyGoal = require("./daily-goal/daily-goal");
var equipmentFeaturedContent = require("./equipment-featured-content/equipment-featured-content");
var event = require("./event/event");
var foodLog = require("./food-log/food-log");
var listWorkout = require("./list-workout/list-workout");
var activityRecommendation = require("./recommendation/activity-recommendation");
var calorieRecommendation = require("./recommendation/calorie-recommendation");
var mealRecommendation = require("./recommendation/meal-recommendation");
var sleepRecommendation = require("./recommendation/sleep-recommendation");
var stepRecommendation = require("./recommendation/step-recommendation");
var workoutRecommendation = require("./recommendation/workout-recommendation");
var shoeLog = require("./shoe-log/shoe-log");
var userLog = require("./user-log/user-log");
var user = require("./user/user");
var workoutOfTheDay = require("./workout-of-the-day/workout-of-the-day");
var workout = require("./workout/workout");
var IfitApiClient = (function () {
    function IfitApiClient(baseURL, privateToken, clientId, clientSecret, req) {
        if (req === void 0) { req = null; }
        this.baseURL = baseURL;
        this.privateToken = privateToken;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        var baseOpts = {
            baseURL: baseURL
        };
        this.noAuthOpts = __assign({}, baseOpts);
        this.bearerOpts = __assign({}, baseOpts, {
            headers: {
                Authorization: null
            }
        });
        this.basicOpts = __assign({}, baseOpts, {
            auth: {
                password: clientSecret,
                username: clientId
            }
        });
        if (privateToken) {
            this.token = privateToken;
        }
        this.req = req || new request_1.default();
        this.ActivityLog = activityLog.createClass(this);
        this.ActivityLogSleep = activityLogSleep.createClass(this);
        this.ActivityLogTypes = activityLogTypes.createClass(this);
        this.ActivityRecommendation = activityRecommendation.createClass(this);
        this.CalorieRecommendation = calorieRecommendation.createClass(this);
        this.CalorieTargets = calorieTargets.createClass(this);
        this.Console = console.createClass(this);
        this.DailyGoal = dailyGoal.createClass(this);
        this.EquipmentFeaturedContent = equipmentFeaturedContent.createClass(this);
        this.Event = event.createClass(this);
        this.FoodLog = foodLog.createClass(this);
        this.ListWorkout = listWorkout.createClass(this);
        this.MealRecommendation = mealRecommendation.createClass(this);
        this.ShoeLog = shoeLog.createClass(this);
        this.SleepRecommendation = sleepRecommendation.createClass(this);
        this.StepRecommendation = stepRecommendation.createClass(this);
        this.User = user.createClass(this);
        this.UserLog = userLog.createClass(this);
        this.Workout = workout.createClass(this);
        this.WorkoutOfTheDay = workoutOfTheDay.createClass(this);
        this.WorkoutRecommendation = workoutRecommendation.createClass(this);
    }
    Object.defineProperty(IfitApiClient.prototype, "token", {
        get: function () {
            return "Bearer " + this.privateToken;
        },
        set: function (value) {
            this.privateToken = value.replace("Bearer ", "");
            this.bearerOpts.headers.Authorization = this.token;
        },
        enumerable: true,
        configurable: true
    });
    IfitApiClient.prototype.login = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var authReq, options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authReq = {
                            client_id: this.clientId,
                            client_secret: this.clientSecret,
                            grant_type: "password",
                            password: password,
                            username: username
                        };
                        options = __assign({}, this.noAuthOpts, {
                            baseURL: this.baseURL.replace("/v1", ""),
                            data: authReq,
                            method: "POST"
                        });
                        return [4, this.req.json("/oauth/token/", options)];
                    case 1:
                        result = _a.sent();
                        this.token = result.access_token;
                        return [2, result];
                }
            });
        });
    };
    return IfitApiClient;
}());
exports.IfitApiClient = IfitApiClient;
//# sourceMappingURL=client.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ifit/ifit-api-v1/out/api/client.js
// module id = 403
// module chunks = 0